import {useNuxtApp} from 'nuxt/app';

export function useTranslation() {
    return useNuxtApp().$i18next;
}
